import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { GlobalModule } from 'src/app/global/global.module';
import { OtherSettingsComponent } from './other-settings.component';

@NgModule({
    declarations: [OtherSettingsComponent],
    imports: [CommonModule, ReactiveFormsModule, MatProgressSpinnerModule, MatDialogModule, TranslateModule, GlobalModule],
    exports: [OtherSettingsComponent],
})
export class OtherSettingsModule {}
